import { h } from 'vue'
import Notify from 'quasar/src/plugins/Notify.js';

import ReferenceLink from '@/components/shared/ReferenceLink.vue'

export const useNotify = () => {
  const notifyInfo = (message, config) =>
    Notify.create({ message: message, color: 'info', icon: 'mdi-information-outline', ...config })

  const notifySuccess = (message, config) =>
    Notify.create({ message: message, color: 'positive', icon: 'mdi-check-circle-outline', ...config })

  const notifyError = (message, config) =>
    Notify.create({ message: message, color: 'negative', icon: 'mdi-alert-outline', ...config })

  const notifyWarning = (message, config) =>
    Notify.create({
      message: message,
      color: 'warning',
      textColor: 'dark',
      icon: 'mdi-alert-circle-outline',
      html: true,
      ...config
    })

  const notifyInfoWithLink = (linkProps, localizationKey, config, t) => {
    const vnode = h('span', {}, [
      h(ReferenceLink, linkProps),
      ' ',
      t(localizationKey)
    ])

    Notify.create({
      message: vnode,
      color: 'info',
      timeout: window.config.NOTIFICATION_DURATION,
      ...config
    })
  }

  return { notifyInfo, notifySuccess, notifyError, notifyWarning, notifyInfoWithLink }
}
